import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Link from './Link'
import Button from './Button'
import EnterpriseContactModal from './EnterpriseContactModal'

import { closeMenu } from '../../reducers/menu'
import { showModal } from '../../reducers/modal'

import { AIR_URL, MAKERS_URL, CONSOLE_URL, TOKEN_SALE_URL } from '../../config'

import { trackEvent, trackThenLeaveToDevConsole } from '../../utils/tracking'

const MENU_LINKS = [
  {
    label: 'Snips AIR',
    href: AIR_URL,
    forceAnchorElement: true
  },
  {
    label: 'Developers',
    href: MAKERS_URL,
    forceAnchorElement: true
  },
  // enterprise is currently listed below regular options
  // {
  //   label: 'Enterprise',
  //   href: '/enterprise/'
  // },
  {
    label: 'Technology',
    href: '/technology/'
  },
  {
    label: 'Token Sale',
    href: TOKEN_SALE_URL,
    forceAnchorElement: true
  }
]

const Menu = ({ isShowing, activePathname, closeMenu, showModal }) => {
  const classes = classnames(
    {
      'menu--showing': isShowing
    },
    'menu'
  )
  return (
    <div className={classes} onClick={closeMenu}>
      <nav
        className='menu__list center px2 py1'
        onClick={e => {
          e.nativeEvent.stopImmediatePropagation() // Prevent click bubbling and closing modal
          e.stopPropagation()
        }}
      >
        {MENU_LINKS.map(
          ({ label, href, forceAnchorElement, target, isNew }, idx) => {
            const activePage = href === activePathname
            const menuItemClasses = classnames(
              {
                'menu__item--active': activePage,
                'menu__item--new': isNew
              },
              'block py2 menu__item menu__list-item-content'
            )
            return (
              <div className='menu__item-container' key={idx}>
                <Link
                  className={menuItemClasses}
                  href={href}
                  target={target}
                  forceAnchorElement={forceAnchorElement}
                >
                  {label}
                </Link>
              </div>
            )
          }
        )}

        <div className='py2'>
          <div className='block py2 menu__item'>
            <a
              className='homepage-hero-section__actions__button button button--primary mx-auto'
              href={CONSOLE_URL}
              onClick={e => trackThenLeaveToDevConsole(e, 'Menu')}
            >
              Sign Up
            </a>
          </div>

          <div className='block py2 menu__item'>
            <Button
              className='homepage-hero-section__actions__button button full-width mx-auto'
              onClick={() => {
                trackEvent('EnterpriseContactModal', 'MobileMenu')
                showModal(<EnterpriseContactModal />)
              }}
            >
              Contact Enterprise
            </Button>
          </div>
        </div>
      </nav>
    </div>
  )
}

Menu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  activePathname: PropTypes.string.isRequired
}

const mapStateToProps = ({ menu: { isShowing }, location: { pathname } }) => {
  return { isShowing, activePathname: pathname }
}

export default connect(mapStateToProps, { closeMenu, showModal })(Menu)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Menu.js